import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "../../components/global/Header";
import Newsletter from "../../components/Newsletter";
import Workwithus from "../../components/academy/Workwithus";
import Loopingpromo from "../../components/global/Loopingpromo";
import Footer from "../../components/global/Footer";
import Istqb from "../../components/global/Istqb";
import ScrollToTopButton from "../../components/global/ScrollToTop";
import FormKontaktGlobal from "../../components/global/FormKontaktGlobal";
import { useLocation } from "react-router-dom";
import ModalOverlay from "../../components/global/ModalOverlay";
import SuccessStoriesComponent from "../../components/successStories/SuccessStoriesComponent";

const SuccessStories = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const [openContactForm, setContactForm] = useState(false);
    const handleClick = (e) => {
        if (e.target.id === "bg") {
            setContactForm(false);
        }
    }

    return (
        <Box>
            <Header />
            {/* Scroll to top */}
            <ScrollToTopButton />
            {/* looping promotion */}
            <Loopingpromo />
            {/* form contact */}
            {openContactForm  && (
                <ModalOverlay handleClick={handleClick}>
                    <FormKontaktGlobal setContactForm={setContactForm} />
                </ModalOverlay>
            )}
            <SuccessStoriesComponent />
            {/* ISTQB */}
            <Istqb />
            {/* work with us */}
            <Workwithus />
            {/* newsletter subscription */}
            <Newsletter />
            <Footer setContactForm={setContactForm} />
        </Box>
    );
};

export default SuccessStories;
